<template>
  <CommonModal>
    <template slot="header">
      <h3>Add Image</h3>
    </template>
    <template slot="body">
      <div class="d-flex">
        <div class="m-2">
          <img v-bind:src="imgUrl" >
        </div>
        <div class="m-2">
          <input id="file" type="file" style="display: none;" @change="upload" multiple/>
          <div class="upload_area">
            <a href="#" class="upload_bt" @click="AC_fileClick()">Upload</a>
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <slot name="footer">
      </slot>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modal/CommonModal";
import {uploadDocTypeImg} from "@/api/document";
import $ from "jquery";

export default {
  components: {
    CommonModal ,
  },
  data() {
    return {
      imgUrl:'',
      form : {
        doctypeId : '',
        file : ''
      },
    };
  },
  methods: {
    async fetchData(doctypeId){
      this.form.doctypeId = doctypeId;
      this.imgUrl = "/mgmt/doctype/img/" +  doctypeId + "?" + new Date().getTime();
    },
    async upload(event) {

      let formData = new FormData();
      formData.append('file', event.target.files[0]);
      formData.append('doctypeId', this.form.doctypeId);

      try {
        const response = await uploadDocTypeImg(formData);
        await this.fetchData(this.form.doctypeId);
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
    AC_fileClick() {
      $('#file').click();
    }
  }
}
</script>

<style>
</style>